<template>
  <div class="calibration">
    <el-tabs
      v-model="activeName"
      :tab-position="screenWidth > 1023 ? 'left' : 'top'"
    >
      <el-tab-pane name="capacitance_readings">
        <div class="left-tab-label" slot="label">
          <div class="label-title">
            {{ $t('text.calibration') | firstLetterCapitalize }}
          </div>
          <div class="label-desc">Calibration desc</div>
        </div>
        <div class="common-title-page">
          <div class="page-title mt-10">
            {{ $t('text.pod_calibration') }}
          </div>
          <span :class="screenWidth > 767 ? 'right-float mb-10' : 'mt-30'">
            <img src="../../assets/filter.svg" />
            <el-input
              v-model="filter"
              size="mini"
              class="search-input filter-input"
              placeholder="filter by pod ID"
            ></el-input>
          </span>
          <el-table
            border
            ref="table"
            :data="tableData"
            size="small"
            v-loading="loading"
            :max-height="tableHeight"
          >
            <el-table-column :label="$t('text.pod') + ' ID'" prop="podId">
            </el-table-column>
            <el-table-column :label="$t('text.calibrattion_status')">
              <template slot-scope="scope">
                <div>
                  {{ $t('text.capacitive') }}:{{ scope.row.capactive_cal }}
                </div>
                <div>
                  {{ $t('text.accelerometer') }}:{{
                    scope.row.accelerometer_cal
                  }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              fixed="right"
              :label="$t('text.action') | firstLetterCapitalize"
              v-if="p('Pods.Calibration.Edit')"
            >
              <template slot-scope="scope">
                <b-button
                  size="sm"
                  variant="outline-success"
                  class="min-w-80"
                  @click="edit(scope.row)"
                  >{{ $t('text.view') | firstLetterCapitalize }}/{{
                    $t('text.edit') | firstLetterCapitalize
                  }}</b-button
                >
              </template>
            </el-table-column>
          </el-table>
          <div class="text-right">
            <b-button
              size="sm"
              variant="outline-success"
              class="min-w-80 mt-30"
              @click="add()"
              v-if="p('Pods.Calibration.Add')"
              >{{ $t('text.add') | firstLetterCapitalize }}</b-button
            >
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>
    <EditCalibration ref="editCalibration" />
  </div>
</template>

<script>
// import PatientInput from '@/components/PatientInput'
import EditCalibration from '@/components/pods/calibration/EditCalibration'
import $ from 'jquery'
import ApiService from '@/services/CommonApiService.js'
export default {
  data() {
    return {
      loading: false,
      activeName: 'capacitance_readings',
      screenWidth: window.innerWidth,
      tableData: [],
      filter: '',
      timer: '',
      tableHeight: 0
    }
  },
  components: {
    // PatientInput,
    EditCalibration
  },
  mounted: function() {
    window.addEventListener('resize', this.getScreenWidth)
    this.getScreenWidth()
    this.getData()
    this.$nextTick(() => {
      this.tableHeight =
        window.innerHeight - this.$refs.table.$el.offsetTop - 200
      let self = this
      window.onresize = function() {
        self.tableHeight =
          window.innerHeight - self.$refs.table.$el.offsetTop - 200
      }
    })
  },
  watch: {
    filter() {
      if (this.timer) {
        clearTimeout(this.timer)
      }
      this.timer = setTimeout(this.getData, 500)
    }
  },
  methods: {
    getScreenWidth() {
      this.screenWidth = window.innerWidth
      if (this.screenWidth < 1023) {
        $('.calibration .el-tabs__header').hide()
      } else {
        $('.calibration .el-tabs__header').show()
      }
    },
    getData() {
      this.loading = true
      ApiService.GetPodCharacteristics()
        .then(response => {
          this.loading = false
          let vm = this
          this.tableData = response.data.data.filter(item => {
            return (
              item.podId.toLowerCase().indexOf(vm.filter.toLowerCase()) > -1
            )
          })
        })
        .catch(() => {
          this.loading = false
        })
    },
    add() {
      this.$refs.editCalibration.openDialog()
    },
    edit(row) {
      this.$refs.editCalibration.openDialog()
      this.$refs.editCalibration.form = JSON.parse(JSON.stringify(row))
    }
  },
  beforeDestroy() {
    clearInterval(this.timer)
  }
}
</script>
